/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Erp_Invoice_SetupInputs */

const en_reference_dataset_erp_invoice_setup = /** @type {(inputs: Reference_Dataset_Erp_Invoice_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices file to the ERP`)
};

/**
* | output |
* | --- |
* | "Invoices file to the ERP" |
*
* @param {Reference_Dataset_Erp_Invoice_SetupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_erp_invoice_setup = /** @type {((inputs?: Reference_Dataset_Erp_Invoice_SetupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Erp_Invoice_SetupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_erp_invoice_setup(inputs)
});